import * as type from './types';

export function openHelpPane(topic) {
  return function (dispatch) {
    dispatch({
      type: type.UPDATE_HELP_PANE_STATE,
      payload: { isOpen: true, activeTopic: topic },
    });
  };
}

export function closeHelpPane() {
  return function (dispatch) {
    dispatch({
      type: type.UPDATE_HELP_PANE_STATE,
      payload: { isOpen: false },
    });
  };
}
